module.exports = __webpack_public_path__ + "img/hr-boiler-E-idle.9b699eb2.png";